<app-secondary-toolbar [self]="getTitle()">
</app-secondary-toolbar>
<div class="container-horizontal-padding container-vertical-padding-half animated fadeIn">
  <form class="form-horizontal bordered-row" (ngSubmit)="acceptOffer()" #f="ngForm" novalidate>
    <div class="card-custom-padding-complete" *ngIf="clientDocument">

      <!-- Offer Details Card -->
      <div class="card mb-2">
        <div class="card-header">
          {{ 'COLONNADE_ONLINE_OFFER_DATA' | translate }}
        </div>
        <div class="card-body">
          <!-- region OfferNumber -->
          <div class="form-group row">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_OFFER_NUMBER' | translate }}</label>
            <label class="col-8 col-form-label detail-description"
                   *ngIf="clientDocument.offerId">{{ clientDocument.offerId }}</label>
          </div>
          <!-- endregion OfferNumber -->

          <!-- region SponsorBranch -->
          <div class="form-group row">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_SPONSOR_BRANCH' | translate }}</label>
            <label class="col-8 col-form-label detail-description"
                   *ngIf="clientDocument.form.sponsor && clientDocument.form.branch">{{ clientDocument.form.sponsor.text }}
              / {{ clientDocument.form.branch.text }}</label>
          </div>
          <!-- endregion SponsorBranch -->

          <!-- region InsuranceProduct -->
          <div class="form-group row" *ngIf="clientDocument.form.insuranceProduct">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_INSURANCE_PRODUCT' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.insuranceProduct.text }}</label>
          </div>
          <!-- endregion InsuranceProduct -->

          <!-- region InsuranceType -->
          <div class="form-group row" *ngIf="clientDocument.form.insuranceType">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_INSURANCE_TYPE' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.insuranceType.text }}</label>
          </div>
          <!-- endregion InsuranceType -->

          <!-- region InsuranceLevel -->
          <div class="form-group row" *ngIf="clientDocument.form.insuranceLevel">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_INSURANCE_LEVEL' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.insuranceLevel.level }}</label>
          </div>
          <!-- endregion InsuranceLevel -->
        </div>
      </div>

      <!-- Contracting Customer Details Card -->
      <div class="card mb-2" *ngIf="clientDocument.form.contractingCustomerRecord">
        <div class="card-header">
          {{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_DATA' | translate }}
        </div>
        <div class="card-body">
          <!-- region ContractingCustomerName -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.name">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_NAME' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.contractingCustomerRecord.name }}</label>
          </div>
          <!-- endregion ContractingCustomerName -->

          <!-- region ContractingCustomerBirthName -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.birthName">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_BIRTH_NAME' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.contractingCustomerRecord.birthName }}</label>
          </div>
          <!-- endregion ContractingCustomerBirthName -->

          <!-- region ContractingCustomerDateOfBirth -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.dateOfBirth">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_DATE_OF_BIRTH' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.contractingCustomerRecord.dateOfBirth.toIsoString() | date: 'mediumDate' }}</label>
          </div>
          <!-- endregion ContractingCustomerDateOfBirth -->

          <!-- region ContractingCustomerPostalAddress -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.postalAddress">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_POSTAL_ADDRESS' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ formatAddress(clientDocument.form.contractingCustomerRecord.postalAddress) }}</label>
          </div>
          <!-- endregion ContractingCustomerPostalAddress -->

          <!-- region ContractingCustomerNotificationAddress -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.notificationAddress">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_NOTIFICATION_ADDRESS' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ formatAddress(clientDocument.form.contractingCustomerRecord.notificationAddress) }}</label>
          </div>
          <!-- endregion ContractingCustomerNotificationAddress -->

          <!-- region ContractingCustomerEmployeeId -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.employeeId">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_EMPLOYEE_ID' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.contractingCustomerRecord.employeeId }}</label>
          </div>
          <!-- endregion ContractingCustomerEmployeeId -->

          <!-- region ContractingCustomerPhoneNumberMobile -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.phoneNumbers">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_PHONE_NUMBER_MOBILE' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ getPrivatePhoneNumber(clientDocument.form.contractingCustomerRecord.phoneNumbers) }}</label>
          </div>
          <!-- endregion ContractingCustomerPhoneNumberMobile -->

          <!-- region ContractingCustomerEmailAddress -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord.emailAddresses">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_EMAIL_ADDRESS' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ getEmailAddress(clientDocument.form.contractingCustomerRecord.emailAddresses) }}</label>
          </div>
          <!-- endregion ContractingCustomerEmailAddress -->

          <!-- region ContractingCustomerNumberOfChildren -->
          <div class="form-group row"
               *ngIf="clientDocument.form.contractingCustomerRecord.numberOfChildren !== undefined && clientDocument.form.contractingCustomerRecord.numberOfChildren !== null">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_NUMBER_OF_CHILDREN' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.contractingCustomerRecord.numberOfChildren }}</label>
          </div>
          <!-- endregion ContractingCustomerNumberOfChildren -->

          <!-- region ContractingCustomerExternalId -->
          <div class="form-group row" *ngIf="clientDocument.form.contractingCustomerRecord?.externalId">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_CONTRACTING_CUSTOMER_EXTERNAL_ID' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.contractingCustomerRecord.externalId }}</label>
          </div>
          <!-- endregion ContractingCustomerExternalId -->

        </div>
      </div>

      <!-- Insured Customer Details Card -->
      <div class="card mb-2" *ngIf="clientDocument.form.insuredCustomerRecord">
        <div class="card-header">
          {{ 'COLONNADE_ONLINE_INSURED_CUSTOMER_DATA' | translate }}
        </div>
        <div class="card-body">
          <!-- region InsuredCustomerName -->
          <div class="form-group row" *ngIf="clientDocument.form.insuredCustomerRecord.name">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_INSURED_CUSTOMER_NAME' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.insuredCustomerRecord.name }}</label>
          </div>
          <!-- endregion InsuredCustomerName -->

          <!-- region InsuredCustomerDateOfBirth -->
          <div class="form-group row" *ngIf="clientDocument.form.insuredCustomerRecord.dateOfBirth">
            <label
              class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_INSURED_CUSTOMER_DATE_OF_BIRTH' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.insuredCustomerRecord.dateOfBirth.toIsoString() | date: 'mediumDate' }}</label>
          </div>
          <!-- endregion InsuredCustomerDateOfBirth -->

        </div>
      </div>

      <!-- Payment Details Card -->
      <div class="card mb-2">
        <div class="card-header">
          {{ 'COLONNADE_ONLINE_PAYMENT_DATA' | translate }}
        </div>
        <div class="card-body">
          <!-- region Price -->
          <div class="form-group row" *ngIf="clientDocument.form.insuranceLevel">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_PRICE' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.insuranceLevel.price }} Ft</label>
          </div>
          <!-- endregion Price -->

          <!-- region VipDiscount -->
          <div class="form-group row" *ngIf="clientDocument.form.vipDiscount">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_VIP_DISCOUNT' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.vipDiscount.discountPercent }}%</label>
          </div>
          <!-- endregion VipDiscount -->

          <!-- region SponsorDiscount -->
          <div class="form-group row" *ngIf="clientDocument.form.sponsorDiscount && (clientDocument.form.sponsorDiscount.discountForint > 0 || clientDocument.form.sponsorDiscount.discountPercent > 0)">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_SPONSOR_DISCOUNT' | translate }}</label>
            <label class="col-8 col-form-label detail-description"
                   *ngIf="clientDocument.form.sponsorDiscount.discountForint">
              {{ clientDocument.form.sponsorDiscount.discountForint }} Ft</label>
            <label class="col-8 col-form-label detail-description"
                   *ngIf="clientDocument.form.sponsorDiscount.discountPercent">
              {{ clientDocument.form.sponsorDiscount.discountPercent }}%</label>
          </div>
          <!-- endregion SponsorDiscount -->

          <!-- region DiscountPrice -->
          <div class="form-group row" *ngIf="clientDocument.form.insuranceLevel.discountedPrice">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_DISCOUNT_PRICE' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.insuranceLevel.discountedPrice }} Ft</label>
          </div>
          <!-- endregion DiscountPrice -->

          <!-- region PaymentType -->
          <div class="form-group row" *ngIf="clientDocument.form.paymentType">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_PAYMENT_TYPE' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.paymentType.text }}</label>
          </div>
          <!-- endregion PaymentType -->

          <!-- region BankAccountNumber -->
          <div class="form-group row" *ngIf="clientDocument.form.bankAccountNumber">
            <label class="col-4 col-form-label">{{ 'COLONNADE_ONLINE_BANK_ACCOUNT_NUMBER' | translate }}</label>
            <label class="col-8 col-form-label detail-description">
              {{ clientDocument.form.bankAccountNumber }}</label>
          </div>
          <!-- endregion BankAccountNumber -->

        </div>
      </div>

      <!-- Beneficiary Customer Details Card -->
      <div class="card mb-2"
           *ngIf="clientDocument.form.beneficiaryCustomerRecords && clientDocument.form.beneficiaryCustomerRecords.length > 0">
        <div class="card-header">
          {{ 'COLONNADE_ONLINE_BENEFICIARY_CUSTOMER_DATA' | translate }}
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-striped table-bordered mb-0">
              <thead>
              <tr>
                <th>{{ 'COLONNADE_ONLINE_BENEFICIARY_CUSTOMER_NAME' | translate }}</th>
                <th>{{ 'COLONNADE_ONLINE_BENEFICIARY_CUSTOMER_POSTAL_ADDRESS' | translate }}</th>
                <th>{{ 'COLONNADE_ONLINE_BENEFICIARY_CUSTOMER_PLACE_OF_BIRTH' | translate }}</th>
                <th>{{ 'COLONNADE_ONLINE_BENEFICIARY_CUSTOMER_DATE_OF_BIRTH' | translate }}</th>
                <th>{{ 'COLONNADE_ONLINE_BENEFICIARY_CUSTOMER_MOTHERS_NAME' | translate }}</th>
                <th>{{ 'COLONNADE_ONLINE_BENEFICIARY_RATE' | translate }}</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let beneficiary of clientDocument.form.beneficiaryCustomerRecords">
                <td>{{ beneficiary.name }}</td>
                <td>{{ formatAddress(beneficiary.postalAddress) }}</td>
                <td>{{ beneficiary.placeOfBirth }}</td>
                <td>{{ beneficiary.dateOfBirth ? (beneficiary.dateOfBirth.toIsoString() | date: 'mediumDate') : '' }}</td>
                <td>{{ beneficiary.mothersName }}</td>
                <td>{{ beneficiary.beneficiaryRate ? beneficiary.beneficiaryRate + '%' : '' }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Consents & Statements Card -->
      <div class="card mb-2">
        <div class="card-header">
          {{ 'COLONNADE_ONLINE_CONSENTS_AND_STATEMENTS' | translate }}
        </div>
        <div class="card-body">
          <!-- region PersonalInformationProvided -->
          <div class="row mr-0 ml-0 mt-1 align-items-center">
            <label class="col-form-label col-md-4 required-field-label">
              {{ 'COLONNADE_ONLINE_PERSONAL_INFORMATION_PROVIDED' | translate }}
            </label>
            <div class="form-group col-md-8 mb-0">
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input"
                       [(ngModel)]="approvalModel.personalInformationProvided"
                       name="personalInformationProvided"
                       #personalInfoProvided="ngModel"
                       required>
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
              <div
                *ngIf="personalInfoProvided.invalid && (personalInfoProvided.dirty || personalInfoProvided.touched || f.submitted)"
                class="text-danger mt-1 small">
                {{ 'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate }}
              </div>
            </div>
          </div>
          <!-- endregion PersonalInformationProvided -->

          <!-- region GatheringPersonalInformationApproved -->
          <div class="row mr-0 ml-0 mt-1 align-items-center">
            <label
              class="col-form-label col-md-4">{{ 'COLONNADE_ONLINE_GATHERING_PERSONAL_INFORMATION_APPROVED' | translate }}</label>
            <div class="form-group col-md-8 mb-0">
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input"
                       [(ngModel)]="approvalModel.gatheringPersonalInformationApproved"
                       name="gatheringPersonalInformationApproved">
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <small class="row mr-0 ml-0 mt-0 pl-1 align-items-center">{{ 'COLONNADE_ONLINE_GATHERING_PERSONAL_INFORMATION_INFO' | translate }}</small>
          <!-- endregion GatheringPersonalInformationApproved -->

          <!-- region MarketingResearchApproved -->
          <div class="row mr-0 ml-0 mt-1 align-items-center">
            <label
              class="col-form-label col-md-4">{{ 'COLONNADE_ONLINE_MARKETING_RESEARCH_APPROVED' | translate }}</label>
            <div class="form-group col-md-8 mb-0">
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input"
                       [(ngModel)]="approvalModel.marketingResearchApproved"
                       name="marketingResearchApproved">
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <small class="row mr-0 ml-0 mt-0 pl-1 align-items-center">{{ 'COLONNADE_ONLINE_MARKETING_RESEARCH_APPROVED_INFO' | translate }}</small>
          <!-- endregion MarketingResearchApproved -->

          <!-- region HomeInsuranceInterested -->
          <div class="row mr-0 ml-0 mt-1 align-items-center">
            <label
              class="col-form-label col-md-4">{{ 'COLONNADE_ONLINE_HOME_INSURANCE_INTERESTED' | translate }}</label>
            <div class="form-group col-md-8 mb-0">
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input"
                       [(ngModel)]="approvalModel.homeInsuranceInterested"
                       name="homeInsuranceInterested">
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <small class="row mr-0 ml-0 mt-0 pl-1 align-items-center">{{ 'COLONNADE_ONLINE_HOME_INSURANCE_INTERESTED_INFO' | translate }}</small>
          <!-- endregion HomeInsuranceInterested -->
        </div>
      </div>

    </div>
    <input type="submit" class="btn btn-primary floating_save_button" *ngIf="clientDocument" value="{{'COLONNADE_ONLINE_ACCEPT_OFFER'|translate}}"/>

  </form>
</div>
